import {lazy, Suspense} from "react"
import Loader from "../custom/loader/main"

const Main = lazy(() => import("../components/merchants/forms/editMerchant1"))

const EditMerchant = () => {
  return (
    <Suspense fallback={<Loader />}>
        <Main />
    </Suspense>
  )
}

export default EditMerchant